export { globalObject } from './globalObject';
export type { GlobalObject } from './globalObject';



// WEBPACK FOOTER //
// ../../../src/globalObject/index.ts